import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';

const StatusFormatter = ({ data }) => {
  const intl = useIntl();
  let message = '-';

  if (data.is_accepted) {
    message = intl.formatMessage({
      id: 'dataGrid.formatters.batches.status.accepted',
      defaultMessage: 'Accepted',
      description: 'The accepted column value for column status',
    });
  }

  if (data.is_confirmed) {
    message = intl.formatMessage({
      id: 'dataGrid.formatters.batches.status.confirmed',
      defaultMessage: 'Confirmed',
      description: 'The confirmed column value for column status',
    });
  }

  if (data.is_ready) {
    message = intl.formatMessage({
      id: 'dataGrid.formatters.batches.status.done',
      defaultMessage: 'Done',
      description: 'The done column value for column status',
    });
  }

  if (data.is_failing) {
    message = intl.formatMessage({
      id: 'dataGrid.formatters.batches.status.failed',
      defaultMessage: 'Failed',
      description: 'The failed column value for column status',
    });
  }

  return <>{message}</>;
};

StatusFormatter.propTypes = {
  data: PropTypes.object,
};

StatusFormatter.defaultProps = {
  data: {},
};

export default StatusFormatter;
